import { render, staticRenderFns } from "./_base-bordered-actions.vue?vue&type=template&id=74f8be74&scoped=true&"
import script from "./_base-bordered-actions.vue?vue&type=script&lang=js&"
export * from "./_base-bordered-actions.vue?vue&type=script&lang=js&"
import style0 from "./_base-bordered-actions.vue?vue&type=style&index=0&id=74f8be74&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f8be74",
  null
  
)

export default component.exports